<template>
  <div class="page has-sidebar has-sidebar-fluid has-sidebar-expand-xl">
    <!-- .page-inner -->
    <div class="page-inner page-inner-fill position-relative">
      <header class="page-navs shadow-sm">
        <!-- .input-group -->
        <div class="input-group has-clearable">
          <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true">
              <em class="fa fa-times-circle"></em>
            </span>
          </button>
          <label class="input-group-prepend" for="searchClients">
            <span class="input-group-text">
              <span class="oi oi-magnifying-glass"></span>
            </span>
          </label>
          <input type="text" class="form-control" id="searchClients" @keyup="inputText"
                 data-filter=".board .list-group-item" placeholder="Find album">
        </div><!-- /.input-group -->
      </header>

      <div class="board p-0 perfect-scrollbar" id="container">
        <!-- .list-group -->
        <div class="list-group list-group-flush list-group-divider border-top" data-toggle="radiolist">
          <template v-for="(list, i) in video_group">
            <div class="list-group-item" :class="{ 'active' : i == 0}" data-toggle="sidebar" data-sidebar="show">
              <a @click="selectItem(list)" class="stretched-link"></a>
              <div class="list-group-item-figure">
                <div class="tile tile-circle" :class="list.bg_color">{{ list.initial }}</div>
              </div>
              <div class="list-group-item-body">
                <h4 class="list-group-item-title">{{ list.name }}</h4>
                <p class="list-group-item-text">{{ list.info }}</p>
              </div>
            </div>
          </template>

          <div class="list-group-item" v-show="loading">
            <!-- .list-group-item-body -->
            <div class="list-group-item-body text-center py-4">
              <!-- .spinner -->
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div><!-- /.spinner -->
            </div><!-- /.list-group-item-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="page-sidebar bg-light">
      <!-- .sidebar-header -->
      <header class="sidebar-header d-xl-none">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="#" onclick="Looper.toggleSidebar()"><em class="breadcrumb-icon fa fa-angle-left mr-2"></em>Back</a>
            </li>
          </ol>
        </nav>
      </header>
      <div class="sidebar-section sidebar-section-fill">
        <h1 class="page-title">
          <em class="far fa-building text-muted mr-2"></em> VIDEO GALLERY
        </h1>
        <div class="section-block">
          <div class="row">
            <!-- grid column -->
            <div class="col-xl-4 col-sm-6" v-for="(item, i) in items" v-bind:key="i">
              <!-- .card -->
              <div class="card">
                <plyr v-if="item.sourcestring === 'youtube.com' ">
                  <div class="plyr__video-embed">
                    <iframe :src="item.file_url" allowfullscreen allow="autoplay" :title="item.file_url"></iframe>
                  </div>
                </plyr>
                <plyr v-else>
                  <video>
                    <source label="" :src="urlVideo+item.file_path+item.filename" :type="item.filetype" />
                    <track label="English" kind="captions"  default>
                  </video>
                </plyr>
              </div><!-- /.card -->
            </div>
          </div>
          <div class="row align-items-center">
            <pagination-info :per-page="perPage" :rows="totalVideo" :current-page="currentPage"></pagination-info>
            <div class="col-sm-12 col-md-7 d-flex justify-content-end">
              <div class="dataTables_paginate paging_simple_numbers">
                <b-pagination v-model="currentPage" :per-page="perPage" v-on:click="getListVideo(selected_item)"
                              :total-rows="totalVideo"></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import plyr from 'vue-plyr'
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import PaginationInfo from "../../PaginationInfo";
import {BPagination} from "bootstrap-vue";

export default {
  name: "VideoGallery",
  components:{
    PaginationInfo,
    BPagination,
    plyr
  },
  data(){
    return {
      video_group : [],
      items:[],
      currentPage:1,
      perPage:9,
      totalVideo:0,
      bg_color:['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray'],
      ps:null,
      loading:false,
      currentOffset: 1,
      limit:10,
      total:0,
      selected_item:null,
      urlVideo:process.env.VUE_APP_URL_BACKEND
    }
  },
  watch:{
    currentPage(){
      this.getListVideo()
    }
  },
  methods:{
    selectItem(item){
      this.selected_item = item
      this.getListVideo()
    },
    getListVideo(){
      this.items = []
      let payload = {
        id : this.selected_item.id,
        page:this.currentPage,
        limit:this.perPage
      }

      AxiosCall.Get(payload, urlApi.intranet.list_video).then(res=>{
        if(res.success){
          for (let data of res.atributes){
            data.filetype = "video/"+data.file_type
            data.sourcestring  = data.file_url.replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/)[0];
            this.items.push(data)
          }
          this.totalVideo = res.total
        }
      })
    },
    getData(){
      let payload = {
        page : this.currentOffset,
        limit:this.limit
      }
      this.loading = true
      AxiosCall.Get(payload, urlApi.intranet.list_video_group).then(res=>{
        if(res.success){
          for (let i in res.atributes){
            let data = res.atributes[i]
            const random = this.random()
            if(i != 0 ){
              data.bg_color = this.bg_color[random] === res.atributes[i-1].bg_color ? this.bg_color[this.random()] : this.bg_color[random]
            }else {
              data.bg_color = this.bg_color[random]
            }

            data.initial = data.name.match(/\b(\w)/g).join('')

            if(this.selected_item == null && i == 0){
                this.selected_item = data
                this.getListVideo()
            }
            this.video_group.push(data)
          }
          this.currentOffset++
          this.total = res.total
        }
        this.loading = false
      }).catch(e=>{
        this.loading = false
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    inputText(){
      let myDiv = document.getElementById('container');
      myDiv.scrollTop = 0
    },
    random(){
      let key = this.getRandomInt(0, 10);
      return key
    },
    getRandomInt(min, max) {
      // Create byte array and fill with 1 random number
      let byteArray = new Uint8Array(1);
      window.crypto.getRandomValues(byteArray);

      let range = max - min + 1;
      let max_range = 256;
      if (byteArray[0] >= Math.floor(max_range / range) * range)
        return this.getRandomInt(min, max);

      return min + (byteArray[0] % range);
    },
  },
 created() {
    this.getData()
 },
  mounted() {
    let ini = this
    if (window.PerfectScrollbar && $('.perfect-scrollbar').length > 0) {
      let ps
      $('.perfect-scrollbar:not(".aside-menu")').each(function () {
        if(this.id === 'container'){
          ps = new PerfectScrollbar(this, {
            suppressScrollX: true,
            wheelPropagation: false,
          })
          document.querySelector('#container').addEventListener('ps-y-reach-end', () => {
            setTimeout(()=>{

              if(!ini.loading) {
                  ini.getData()
              }

              setTimeout(()=>{
                ps.update()
              }, 10)
            }, 20)



          });
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
video {max-height:320px!important}
</style>